import Login from './client'
/**
 * 登录及权限相关的路由守卫判断和执行
 */
export const loginRouterGuard = (router) => {
  router.beforeEach(async (to, from, next) => {
    // 白名单
    if (to.meta.isNoAuth) {
      return next()
    }
    // 使用不同的登录守卫
    // console.log('守卫入口执行，登录态：', { to, Login })
    await Login.value.routerGuard(to, from, next)
    next()
  })
}
